module.exports = __webpack_public_path__ + "media/images/themes/mandy/bg1-51ca46fa75e8db60298ce3ade93db270.png";